"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div className="container mx-auto flex h-screen flex-col justify-between">
          <header className="flex items-center justify-between gap-4 px-4 py-4">
            <img src="/logo.svg" />
          </header>
          <div className="flex w-full flex-col items-center">
            <div className="w-full max-w-[400px]">
              <h1 className="text-2xl font-bold">Error</h1>
              <h2>Uh oh! Something went wrong.</h2>
              <p>We're having trouble right now. Please try again later.</p>
            </div>
          </div>
          <div className="py-6">
            <div className="min-h-[20px]"></div>
          </div>
        </div>
      </body>
    </html>
  );
}
